const WINDOW_LIMITS = {
    /* 1-st page */
    "4 9/16 SINGLE SLIDER TILT": {
        DOUBLE: { minW: 19, maxW: 68, minH: 13, maxH: 46, maxSq: 21 }, 
        TRIPLE: { minW: 19, maxW: 64, minH: 13, maxH: 44, maxSq: 19 }
    },
    "4 9/16 SINGLE SLIDER LIFT OUT": {
        DOUBLE: { minW: 19, maxW: 72, minH: 13, maxH: 52, maxSq: 26 }, 
        TRIPLE: { minW: 19, maxW: 72, minH: 13, maxH: 52, maxSq: 26 }
    },
    "4 9/16 SINGLE SLIDER OFFSET": {
        DOUBLE: { minW: 19, maxW: 84, minH: 13, maxH: 46, maxSq: 26 }, 
        TRIPLE: { minW: 19, maxW: 84, minH: 13, maxH: 44, maxSq: 24 }
    },
    "4 9/16 SINGLE SLIDER OFFSET LO": {
        DOUBLE: { minW: 19, maxW: 84, minH: 13, maxH: 46, maxSq: 26 }, 
        TRIPLE: { minW: 19, maxW: 84, minH: 13, maxH: 44, maxSq: 24 }
    },
    "4 9/16 SINGLE HUNG": {
        DOUBLE: { minW: 15, maxW: 46, minH: 24, maxH: 78, maxSq: 25 }, 
        TRIPLE: { minW: 15, maxW: 44, minH: 24, maxH: 66, maxSq: 21 }
    },
    "4 9/16 SINGLE HUNG OFFSET": {
        DOUBLE: { minW: 15, maxW: 46, minH: 24, maxH: 84, maxSq: 26 }, 
        TRIPLE: { minW: 15, maxW: 44, minH: 24, maxH: 72, maxSq: 22 }
    },
    "4 9/16 END-VENT TILT": {
        DOUBLE: { minW: 58, maxW: 120, minH: 13, maxH: 46, maxSq: 36 }, 
        TRIPLE: { minW: 58, maxW: 112, minH: 13, maxH: 44, maxSq: 34 }
    },
    "4 9/16 END-VENT TILT LIFT OUT": {
        DOUBLE: { minW: 58, maxW: 120, minH: 13, maxH: 50, maxSq: 41.5 }, 
        TRIPLE: { minW: 58, maxW: 112, minH: 13, maxH: 46, maxSq: 35.5 }
    },
    "4 9/16 CASEMENT": {
        DOUBLE: { minW: 15.5, maxW: 38, minH: 18, maxH: 72, maxSq: 18   }, 
        TRIPLE: { minW: 15.5, maxW: 36, minH: 18, maxH: 72, maxSq: 14.5 }
    },
    "4 9/16 AWNING": {
        DOUBLE: { minW: 14.5, maxW: 60, minH: 14, maxH: 60, maxSq: 17 }, 
        TRIPLE: { minW: 14.5, maxW: 50, minH: 14, maxH: 50, maxSq: 16 }
    },
    "4 9/16 PICTURE": {
        DOUBLE: { minW: 10, maxW: 120, minH: 10, maxH: 120, maxSq: 30 }, 
        TRIPLE: { minW: 10, maxW: 60,  minH: 10, maxH: 60,  maxSq: 25 }
    },
    "4 9/16 HIGH FIXED": {
        DOUBLE: { minW: 10, maxW: 120, minH: 10, maxH: 120, maxSq: 50 },  //10 or 15
        TRIPLE: { minW: 10, maxW: 96,  minH: 10, maxH: 96,  maxSq: 33 }
    },
    /* 2-nd page */
    "SINGLE SLIDER TILT": {
        DOUBLE: { minW: 19, maxW: 68, minH: 13, maxH: 46, maxSq: 21 }, 
        TRIPLE: { minW: 19, maxW: 64, minH: 13, maxH: 44, maxSq: 19 }
    },
    "SINGLE SLIDER LIFT OUT": {
        DOUBLE: { minW: 19, maxW: 70, minH: 13, maxH: 50, maxSq: 26 }, 
        TRIPLE: { minW: 19, maxW: 70, minH: 13, maxH: 50, maxSq: 26 }
    },

    "SINGLE SLIDER OFFSET": {
        DOUBLE: { minW: 19, maxW: 84, minH: 13, maxH: 46, maxSq: 26 }, 
        TRIPLE: { minW: 19, maxW: 84, minH: 13, maxH: 44, maxSq: 24 }
    },

    "SINGLE SLIDER LO OFFSET": {
        DOUBLE: { minW: 19, maxW: 84, minH: 13, maxH: 46, maxSq: 26 }, 
        TRIPLE: { minW: 19, maxW: 84, minH: 13, maxH: 44, maxSq: 24 }
    },

    "DOUBLE SLIDER TILT": {
        DOUBLE: { minW: 24, maxW: 65, minH: 16, maxH: 46, maxSq: 20 }, 
        TRIPLE: { minW: 24, maxW: 62, minH: 16, maxH: 42, maxSq: 18 }
    },
    "DOUBLE SLIDER LIFT OUT": {
        DOUBLE: { minW: 24, maxW: 65, minH: 16, maxH: 46, maxSq: 20 }, 
        TRIPLE: { minW: 24, maxW: 62, minH: 16, maxH: 42, maxSq: 18 }
    },
    "SINGLE HUNG": {
        DOUBLE: { minW: 15, maxW: 46, minH: 24, maxH: 78, maxSq: 25 }, 
        TRIPLE: { minW: 15, maxW: 44, minH: 24, maxH: 66, maxSq: 11 }
    },
    "SINGLE HUNG OFFSET": {
        DOUBLE: { minW: 15, maxW: 46, minH: 24, maxH: 84, maxSq: 26 }, 
        TRIPLE: { minW: 15, maxW: 44, minH: 24, maxH: 72, maxSq: 22 }
    },
    "DOUBLE HUNG": {
        DOUBLE: { minW: 15, maxW: 46, minH: 28, maxH: 66, maxSq: 21 }, 
        TRIPLE: { minW: 15, maxW: 44, minH: 28, maxH: 64, maxSq: 19 }
    },
    "END-VENT TILT": {
        DOUBLE: { minW: 58, maxW: 120, minH: 13, maxH: 46, maxSq: 36 }, 
        TRIPLE: { minW: 58, maxW: 122, minH: 13, maxH: 44, maxSq: 34 } 
    },
    "END-VENT TILT LIFT OUT": {
        DOUBLE: { minW: 58, maxW: 120, minH: 13, maxH: 50, maxSq: 41.5 }, 
        TRIPLE: { minW: 58, maxW: 122, minH: 13, maxH: 46, maxSq: 35.5 } 
    },


    "3 1/4 CASEMENT": {
        DOUBLE: { minW: 15.5, maxW: 38, minH: 18, maxH: 72, maxSq: 18   }, 
        TRIPLE: { minW: 15.5, maxW: 36, minH: 18, maxH: 72, maxSq: 14.5 }
    },
    "3 1/4 AWNING": {
        DOUBLE: { minW: 14.5, maxW: 60, minH: 14, maxH: 60, maxSq: 17 }, 
        TRIPLE: { minW: 14.5, maxW: 50, minH: 14, maxH: 50, maxSq: 16 }
    },
    "3 1/4 PICTURE": {
        DOUBLE: { minW: 9, maxW: 120, minH: 9, maxH: 120, maxSq: 30 }, 
        TRIPLE: { minW: 9, maxW: 60,  minH: 9, maxH: 60,  maxSq: 25 }
    },
    "3 1/4 HIGH FIXED": {
        DOUBLE: { minW: 12, maxW: 120, minH: 12, maxH: 120, maxSq: 50 },  //10 or 15
        TRIPLE: { minW: 12, maxW: 96,  minH: 12, maxH: 96,  maxSq: 33 }
    },
  };


  export function minmaxWindow(style, pane = 'DOUBLE', frameWidth = '4 9/16' ) {
    const normalizedStyle = style.trim().toUpperCase();
    const normalizedPane = pane.trim().toUpperCase();
  
    const styleData = WINDOW_LIMITS[normalizedStyle];
    if (!styleData) return null;
  
    const paneData = styleData[normalizedPane];
    if (!paneData) return null;
  
    return paneData;
  }
    